/* eslint-disable react/no-danger */
import * as React from 'react';

import type { CarouselCollection } from 'bundles/collections-carousel/types/CarouselCollection';
import { clearEmptyFields } from 'bundles/seo/utils/utils';

type Props = {
  headline?: string | null;
  description?: string | null;
  collections: CarouselCollection[];
};

const CollectionsSchemaMarkup = ({ collections, headline, description }: Props) => {
  // If headline is not provided, use tracking label (or the collection's title field as last resort)
  const markupName = headline || collections[0]?.collectionTrackingData?.label || collections[0].title;

  const markupJson = {
    '@context': 'http://schema.org',
    '@type': 'ItemList',
    name: markupName,
    description,
    numberOfItems: collections[0]?.entities?.length,
    itemListElement: collections[0]?.entities?.map((entity, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: entity.name,
      image: entity.imageUrl,
      url: entity.link ? `https://www.coursera.org${entity.link}` : undefined,
    })),
  };

  const createMarkup = () => ({
    __html: `
      <script type="application/ld+json">
        ${JSON.stringify(clearEmptyFields(markupJson))}
      </script>
    `,
  });

  return (
    <div className="rc-CollectionsSchemaMarkup">
      <div dangerouslySetInnerHTML={createMarkup()} />
    </div>
  );
};

export default CollectionsSchemaMarkup;
